/*
  ____                   _   _
 |  _ \ ___  _ __       | | | |_ __
 | |_) / _ \| '_ \ _____| | | | '_ \
 |  __/ (_) | |_) |_____| |_| | |_) |
 |_|   \___/| .__/       \___/| .__/
            |_|               |_|
==================================================
= Function to call a pop-up.                     =
= The function can work with or without cookies. =
= You can Launch it whenever you want:           =
= Examples : On page launch,On click etc...      =
==================================================
*/

$(document).ready(function(){
  var myCookie = readCookie('popupOpen');

  //Function to open or close the Pop-Up
  function openPopUp(){
    $(".pop-up,.dark-overlay").fadeIn("slow");
    $(".pop-up").toggleClass("opened");
    createCookie('popupOpen','cookieOpen',7);
  }
  function closePopUp(){
    $(".pop-up,.dark-overlay").fadeOut("slow");
  }
  $(".dark-overlay,.close-btn,.pop-up").click(function(){
    closePopUp();
  });

  /*
  -------------------------------
  Open the Pop-up after 2seconds.
  Except if it was opened before.
  -------------------------------
  setTimeout(function(){
    if(myCookie != "cookieOpen"){
      openPopUp();
    }
  }, 2000);
  */

});
